import { createSelector } from "reselect"
import { getSelectedBase } from "modules/portfolio-root/selectors/base"
import { getFullPortfolioBenchmark } from "modules/portfolio-root/selectors/portfolios"
import { getSegment as getAnalyzeTrendsSegment } from "modules/analyze-header/selectors/segment"

export const getBasePositionSet = createSelector(
  [getFullPortfolioBenchmark, getSelectedBase],
  (benchmark, selectedBase) => {
    if (selectedBase) {
      return {
        type: selectedBase.type,
        id: selectedBase.resourceId || selectedBase.id,
        weight: selectedBase.weight,
        ...(selectedBase.experimentId && { experimentId: selectedBase.experimentId }),
      }
    }

    return {
      type: "BENCHMARK",
      id: benchmark.id,
      weight: benchmark.weight,
    }
  },
)

export const getBasePositionSetWithSegment = createSelector(
  [getBasePositionSet, getAnalyzeTrendsSegment],
  (basePositionSet, segment) => ({
    ...basePositionSet,
    segment,
  }),
)

export const getBaseSignature = createSelector(
  [getBasePositionSet],
  (base) => base.id,
)
